import React, { useEffect, useState } from "react";
import './UserPage.css';
import moment from 'moment';
import { useDispatch, useSelector } from "react-redux";
import { getLoading, createUserAsync, setUsersLoading, deleteUserAsync, updateUserAsync } from "../../../features/redux/adminSlice";
import Confirm from "../../ui/Confirm/Confirm";
import SideSlider from "../../ui/SideSlider/SideSlider";
import { useForm } from 'react-forms-handler';
import validator from 'validator';
import { validateByFieldDynamic } from "../../../utils";

const globals = { users: [] };

function UserPage({ users, offices }) {  // Accept offices as a prop
  const dispatch = useDispatch();
  const isLoading = useSelector(getLoading);
  const [filteredUsers, setFilteredUsers] = useState(users);
  const [openForm, setOpenForm] = useState(false);
  const { form, valid, value, id, name, email, officeIds, admin } = useForm({
    id: [''],
    name: ['', (str) => !validator.isEmpty(str)],
    email: ['', [[validator.isEmail, 'Should be valid email!'], [validateByFieldDynamic(() => globals.users.filter(u => u.id !== id.value), 'email'), 'Email exists']]],
    officeIds: [''],  // Add officeIds field
    admin: [false],   // Add admin field
  });

  const { searchField } = useForm({
    searchField: ['']
  });

  useEffect(() => {
    globals.users = users;
    setFilteredUsers(users.filter(u => getSearchableText(u).toLowerCase().includes(searchField.value.toLowerCase())));
  }, [users, searchField]);

  useEffect(() => {
    searchField.stateChange.subscribe((currentValue, prevValue) => {
      setFilteredUsers(users.filter(u => getSearchableText(u).toLowerCase().includes(currentValue.toLowerCase())));
    });
  }, [searchField]);

  const canSave = () => {
    return valid && (officeIds.value.length > 0 || admin.value);
  };

  return (
    <div className="users-dashboard-content">
      <div className="dashboard-header">
        <h1>Admin Dashboard Users</h1>
        <input style={{ width: '20%' }} type="text" className="form-control" {...searchField.inputProps} placeholder="Search" />
        <button className="btn btn-primary" onClick={() => { setOpenForm(true) }}>Add User</button>
      </div>
      <table className="table">
        <thead className="thead-light">
          <tr>
            <th scope="col">#</th>
            <th scope="col">Name</th>
            <th scope="col">Email</th>
            <th scope="col">Created At</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredUsers.map((user, index) => {
            return <tr key={`user-${index}`} className={`${user.deleted_at ? 'deleted' : ''}`}>
              <th scope="row">{index + 1}</th>
              <td>{user.name}</td>
              <td>{user.email}</td>
              <td>{moment(user.createdAt).format("MMM Do YY")}</td>
              {!user.deleted_at && <td>
                <i className={`text-danger fa-solid fa-${isLoading.users !== user.id ? 'trash' : 'circle-notch fa-spin'}`} onClick={() => {
                  Confirm.confirm('Are you sure you want to delete this user? This action cannot be undone').then(() => {
                    dispatch(setUsersLoading(user.id));
                    dispatch(deleteUserAsync(user.id));
                  }).catch((e) => { console.log(e); });
                }}></i>
                <i style={{ marginLeft: '4px', cursor: 'pointer' }} className={`text-primary fa-solid fa-edit`} onClick={() => {
                  form.clearAllFields();
                  id.value = user.id;
                  name.value = user.name;
                  email.value = user.email;
                  officeIds.value = user.offices.map(o => o.id);  // Set officeIds
                  admin.value = user.admin; // Set admin value
                  setOpenForm(true);
                }}></i>
              </td>}
              {user.deleted_at && <td>
                <i style={{ cursor: 'pointer' }} className={`text-success fa-solid fa-${isLoading.users !== user.id ? 'trash-restore' : 'circle-notch fa-spin'}`} onClick={() => {
                  Confirm.confirm('Are you sure you want to restore this user?').then(() => {
                    dispatch(setUsersLoading(user.id));
                  }).catch((e) => { console.log(e); });
                }}></i>
              </td>}
            </tr>
          })}
        </tbody>
      </table>
      <SideSlider open={openForm}>
        <i style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer' }} className={`text-primary fa-solid fa-rectangle-xmark`} onClick={() => {
          setOpenForm(false);
          form.clearAllFields();
        }}></i>
        <form style={{ textAlign: 'left' }}>
          <div className="form-group">
            <label>Name</label>
            <input type="text" {...name.inputProps} className="form-control" placeholder="Enter name" />
            {name.touched && !name.valid && <small className="form-text text-danger">Cannot be empty</small>}
          </div>
          <div className="form-group">
            <label>Email</label>
            <input type="text" {...email.inputProps} className="form-control" placeholder="Enter email" />
            {email.touched && email.errors && <small className="form-text text-danger">{email.errors}</small>}
          </div>
          <div className="form-group">
            <label>Offices</label>
            <select className="form-control" multiple {...officeIds.inputProps} onChange={(e) => {
              officeIds.value = Array.from(e.target.selectedOptions).map(o => o.value);
            }}>
              {offices.map((office, index) => {
                return <option key={`office-${index}`} value={office.id}>{office.name}</option>
              })}
            </select>
          </div>
          <div className="form-group">
            <label>Admin</label>
            <input type="checkbox" {...admin.inputProps} /> Is Admin
          </div>
          <button disabled={!canSave() || isLoading.users} type="submit" className="btn btn-primary" onClick={(e) => {
            if (id.value) {
              dispatch(updateUserAsync(value));
            } else {
              dispatch(createUserAsync(value));
            }
            setOpenForm(false);
            form.clearAllFields();
            e.preventDefault();
          }}>Submit</button>
        </form>
      </SideSlider>
    </div>
  );
}

function getSearchableText(user) {
  return `${user.name}${user.email}${moment(user.createdAt).format("MMM Do YY")}`;
}

export default UserPage;
